<template>
  <div class="user-canvas-container">
    <div class="side-menu-close">
      <i class="la la-times"></i>
    </div><!-- end menu-toggler -->
    <div class="user-canvas-nav">
      <div class="section-tab section-tab-2 text-center pt-4 pb-3 pl-4">
        <ul class="nav nav-tabs" id="myTab" role="tablist">

          <li class="nav-item">
            <a class="nav-link  active" id="account-tab" data-toggle="tab" href="#account" role="tab" aria-controls="account" aria-selected="true">
              Account
            </a>
          </li>
        </ul>
      </div><!-- end section-tab -->
    </div>
    <div class="user-canvas-nav-content">
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="account" role="tabpanel" aria-labelledby="account-tab">
          <div class="user-action-wrap user-sidebar-panel">
            <div class="notification-item">
              <a href="user-dashboard-profile.html" class="dropdown-item">
                <div class="d-flex align-items-center">
                  <div class="avatar avatar-sm flex-shrink-0 mr-2"></div>
                  <span class="font-size-14 font-weight-bold">Admin</span>
                </div>
              </a>
              <div class="list-group drop-reveal-list user-drop-reveal-list">
                <div class="section-block"></div>
                <a href="/logout" class="list-group-item list-group-item-action">
                  <div class="msg-body">
                    <div class="msg-content">
                      <h3 class="title"><i class="la la-power-off mr-2"></i>Logout</h3>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppHeader"
}
</script>

<style scoped>

</style>